<template>
  <v-container>
    <v-row>
      <v-col
        ><v-btn @click="$router.push({ name: 'ConstructionSiteNew' })"
          >新規作成</v-btn
        ></v-col
      >
    </v-row>
    <template v-if="construction_sites.length > 0">
      <v-row dense>
        <v-col
          v-for="construction_site in construction_sites"
          :key="construction_site.id"
          cols="12"
          md="4"
          lg="3"
        >
          <v-card class="mx-auto" max-width="344">
            <v-img :src="construction_site.image_url" height="200"></v-img>
            <v-card-title>
              {{ construction_site.name }}
            </v-card-title>
            <v-card-actions>
              <v-btn
                color="blue lighten-2"
                text
                @click="
                  $router.push({
                    name: 'ConstructionSiteDetail',
                    params: { id: construction_site.id },
                  })
                "
              >
                詳細
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import api from "@/api";

export default {
  name: "ConstructionSiteIndex",
  data() {
    return {
      construction_sites: [],
    };
  },
  async created() {
    this.construction_sites = await api.construction_sites.list();
  },
};
</script>
